import { Button, Card, Form, Select, Row, Col, Table, Input, Tag, ConfigProvider, Popover, Typography, Pagination, message, Popconfirm } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile';
import { DeleteOutlined, EditOutlined, QuestionCircleOutlined, EyeOutlined } from "@ant-design/icons";
import axios from 'axios';
import './CancelRule.css'
import { Editor } from '@tinymce/tinymce-react';
import { Config } from '../Common/Config';
import { customDropdown } from '../Common/CommonFunction';

const { Option } = Select;
const { Title } = Typography;

/** Derive 1-2 initials from rule name */
const getInitials = (name = '') => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return '?';
};

/** Teal gradient section divider */
const SectionDivider = ({ label }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '16px 0 10px' }}>
    <div style={{ height: 1, flex: 1, background: 'linear-gradient(90deg, #c5e8e8 0%, #e0f5f5 60%, transparent 100%)', borderRadius: 2 }} />
    <span style={{ fontSize: 11, fontWeight: 700, color: '#008385', whiteSpace: 'nowrap', letterSpacing: 0.5, textTransform: 'uppercase' }}>{label}</span>
    <div style={{ height: 1, flex: 1, background: 'linear-gradient(90deg, transparent 0%, #e0f5f5 40%, #c5e8e8 100%)', borderRadius: 2 }} />
  </div>
);


const CancelRule = () => {
    const MAX_CHARS = 250;
    const charCountRefs = useRef({});
    const [userDataSet, setuserDataSet] = useState({})
    const [ruleByName, setruleByName] = useState({})
    const [form] = Form.useForm();
    const [AllClinicianData, setAllClinicianData] = useState([])
    const [loader, setloader] = useState(false)
    const [CurrentPage, setCurrentPage] = useState(1)
    const [isUserCreateEnable, setisUserCreateEnable] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const [showAddButton, setshowAddButton] = useState(true)
    const [editorValue, setEditorValue] = useState();
    const editorRef = useRef(null);
    const editorRef1 = useRef(null);
    const [editTextArea, seteditTextArea] = useState(null)
    const [editTextAreaemail, seteditTextAreaemail] = useState(null)
    const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [mode, setMode] = useState('edit') // modes: 'view', 'edit'
    const isViewMode = mode === 'view'

    let userTempData = localStorage.getItem('userData'), userData = {}
    if (userTempData) {
        userData = JSON.parse(userTempData)
    }
    const userRole = userData?.roles?.[0]?.role_id;
    const isCorporateAdmin = userRole === 4;

    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            getAllCancelData(CurrentPage);
            hasFetched.current = true;
        }
    }, [CurrentPage]);

    const getAllCancelData = async (CurrentPage, searchValue = null) => {
        setloader(true)
        try {
            let url = `${Config.url}cancellation-rule/page/${CurrentPage}`
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setloader(false)
            // console.log('response?.data?.data :::',response?.data?.data?.data)
            if (response?.data?.data?.data) {
                let ruleByName = {}
                response?.data?.data?.data.map(a => {
                    ruleByName[a.name] = a
                })
                setruleByName(ruleByName)
            }
            setAllClinicianData(response?.data?.data)
            hasFetched.current = false;
        } catch (error) {
            console.log('error in cancellation-rule ::::', error)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
            setloader(false)
        }
        setloader(false)
    }


//   
//         const content = editorRef.current?.getContent() || '';
//         const content2 = editorRef1.current?.getContent() || '';
//         console.log('Form values: true', {content,content2});
//         // return
//         if (update != true && ruleByName && ruleByName[values.name] && ruleByName[values.name].name == values.name) {
//             messageApi.error({
//                 type: 'error',
//                 content: 'Same name rule already exists.',
//             });
//             return
//         }
//         // return
//         if (content) {
//             console.log('content in if ::::', content)
//             values = {
//                 ...values,
//                 cancellation_email_copy: content || '',
//             }
//         } else if (userDataSet?.cancellation_email_copy) {
//             console.log('content in else ::::', content)
//             values = {
//                 ...values,
//                 cancellation_email_copy: userDataSet?.cancellation_email_copy,
//             }
//         } else {
//             messageApi.error({
//                 type: 'error',
//                 content: 'Please add a cancellation email copy.',
//             });
//             return
//         }

//         if (content2) {
//  console.log('content2 in if ::::', content2)
//             values = {
//                 ...values,
//                 cancellation_sms_copy: content2 || '',
//             }
//         }
//         else if (userDataSet?.cancellation_sms_copy) {
//              console.log('content2 in else ::::', content2)
//             values = {
//                 ...values,
//                 cancellation_sms_copy: userDataSet?.cancellation_sms_copy,
//             }
//         } else {
//             messageApi.error({
//                 type: 'error',
//                 content: 'Please add a cancellation sms copy.',
//             });
//             return
//         }
//         // values = {
//         //     ...values,
//         //     cancellation_email_copy: userDataSet?.cancellation_email_copy,
//         //     cancellation_sms_copy: userDataSet?.cancellation_sms_copy
//         // }
//         setloader(true)
//         if (update != true) {
//             console.log('::::::payload',values)
//             // return
//             try {
//                 let payload = {
//                     ...values
//                 }
//                 const response = await axios.post(`${Config.url}cancellation-rule`, payload, {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${localStorage.getItem('token')}`
//                     }
//                 });
//                 messageApi.success({
//                     type: 'succes',
//                     content: 'Cancel rule added successfully.',
//                 });
//                 setuserDataSet({})
//                 form.setFieldsValue({
//                     "name": "",
//                     "duration": "",
//                     "charge_type": "",
//                     "amount": "",
//                     "cancellation_email_copy": "",
//                     "cancellation_sms_copy": ""
//                 });
//                 setloader(false)
//                 getAllCancelData(CurrentPage)
//             } catch (error) {
//                 messageApi.error({
//                     type: 'error',
//                     content: 'Something Went wrong',
//                 });
//                 // console.log('create user:', error.response?.data || error.message);
//                 // throw error;
//             }

//         } else {
//             if (!Object.keys(userDataSet).length && !userDataSet.cancellation_rule_id) {
//                 return
//             }



//             let url = `${Config.url}cancellation-rule/${userDataSet.cancellation_rule_id}`
//             try {
//                 let payload = {
//                     ...values,
//                 }
//                 // console.log(':::::update::::::payload::::', payload)
//                 const response = await axios.put(url, payload, {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${localStorage.getItem('token')}`
//                     }
//                 });
//                 setuserDataSet({})
//                 form.setFieldsValue({
//                     "name": "",
//                     "duration": "",
//                     "charge_type": "",
//                     "amount": "",
//                     "cancellation_email_copy": "",
//                     "cancellation_sms_copy": ""
//                 });
//                 messageApi.success({
//                     type: 'succes',
//                     content: 'Cancel rule updated successfully',
//                 });
//                 setloader(false)
//                 getAllCancelData(CurrentPage)
//                 setshowEditorOnlyAdd(true)
//             } catch (error) {
//                 messageApi.error({
//                     type: 'error',
//                     content: 'Something Went wrong',
//                 });
//                 console.log('update user:', error.response?.data || error.message);
//                 // throw error;
//             }
//             // console.log("Form values: false", values);
//         }
//         setloader(false)
//         setisUserCreateEnable(false)
//         setshowAddButton(true)
//     };

const onFinish = async (values, update = false) => {
    // Always get the latest content from both editors
    const content = editorRef.current?.getContent() || '';
    const content2 = editorRef1.current?.getContent() || '';
    // console.log('Form values:', { content, content2 });

    // Prevent duplicate rule names when creating
    if (update !== true && ruleByName && ruleByName[values.name] && ruleByName[values.name].name === values.name) {
        messageApi.error({
            type: 'error',
            content: 'Same name rule already exists.',
        });
        return;
    }

    // Always set the values from the editors, even if empty
    values = {
        ...values,
        cancellation_email_copy: content || userDataSet?.cancellation_email_copy,
        // cancellation_sms_copy: content2,
        cancellation_sms_copy:
        editTextArea === 'sms_copy' || showEditorOnlyAdd
            ? content2
            : userDataSet?.cancellation_sms_copy || '',
    };

    // Validation: require at least one for each (remove if you want to allow empty)
    if (!values.cancellation_email_copy) {
        messageApi.error({
            type: 'error',
            content: 'Please add a cancellation email copy.',
        });
        return;
    }
    // if (!values.cancellation_sms_copy) {
    //     messageApi.error({
    //         type: 'error',
    //         content: 'Please add a cancellation sms copy.',
    //     });
    //     return;
    // }

    setIsSubmitting(true);

    if (update !== true) {
        try {
            let payload = { ...values };
            const response = await axios.post(`${Config.url}cancellation-rule`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            messageApi.success({
                type: 'success',
                content: 'Cancel rule added successfully.',
            });
            setuserDataSet({});
            form.setFieldsValue({
                "name": "",
                "duration": "",
                "charge_type": "",
                "amount": "",
                "cancellation_email_copy": "",
                "cancellation_sms_copy": ""
            });
            setisUserCreateEnable(false);
            setshowAddButton(true);
            setloader(false);
            getAllCancelData(CurrentPage);
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: 'Something Went wrong',
            });
            setIsSubmitting(false);
        }
    } else {
        if (!userDataSet?.cancellation_rule_id) {
            setloader(false);
            return;
        }
        let url = `${Config.url}cancellation-rule/${userDataSet.cancellation_rule_id}`;
        try {
            let payload = { ...values };
            const response = await axios.put(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setuserDataSet({});
            form.setFieldsValue({
                "name": "",
                "duration": "",
                "charge_type": "",
                "amount": "",
                "cancellation_email_copy": "",
                "cancellation_sms_copy": ""
            });
            messageApi.success({
                type: 'success',
                content: 'Cancel rule updated successfully',
            });
            setisUserCreateEnable(false);
            setshowAddButton(true);
            setloader(false);
            getAllCancelData(CurrentPage);
            setshowEditorOnlyAdd(true);
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: 'Something Went wrong',
            });
            console.log('update user:', error.response?.data || error.message);
            setIsSubmitting(false);
        }
    }
    setloader(false);
    setIsSubmitting(false);
};
    const columns = [
        {
            title: 'Cancellation rule',
            dataIndex: 'name',
            key: 'name',
            align: "left", 
        },
        {
            title: 'Min. period',
            dataIndex: 'duration',
            key: 'duration',
            align: "left", 
        },
        {
            title: 'Charge',
            dataIndex: 'charge_type',
            key: 'charge_type',
            align: "left", 
            render: (_, record) => (
                <div >
                    {record && record.charge_type && record.charge_type === 'percentage' ? record?.amount + '%' : ' £' + record?.amount}
                </div>
            ),
        },
        {
            title: '',
            key: 'action',
            align: 'left',
            render: (_, record) => (
                <div style={{ textAlign: 'right', marginRight: 2 }} onClick={(e) => e.stopPropagation()}>
                    <Popover
                        placement="left"
                        trigger="click"
                        content={() => popoverContent(record)}
                    >
                        <button
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                                color: '#008385', padding: '0 6px', lineHeight: 1,
                            }}
                        >···</button>
                    </Popover>
                </div>
            ),
        },
    ];

    const popoverContent = (record) => (
        <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
            <div
                className="rule-action-item"
                style={{ color: '#008385' }}
                onClick={(e) => { e.stopPropagation(); handleRowClick(record, false); }}
            >
                <EyeOutlined style={{ fontSize: 15 }} /> View
            </div>
            <div
                className="rule-action-item"
                style={{ color: '#008385' }}
                onClick={(e) => { e.stopPropagation(); handleRowClick(record, true); }}
            >
                <EditOutlined style={{ fontSize: 15 }} /> Edit
            </div>
            {!isCorporateAdmin && (
                <>
                    <div className="rule-action-divider" />
                    <Popconfirm
                        title="Delete rule"
                        description="Are you sure you want to delete this rule?"
                        onConfirm={() => deleteUser(record)}
                        onCancel={(e) => e?.stopPropagation?.()}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        okButtonProps={{ className: 'confirmation-popup-ok-button' }}
                        cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
                        okText="Yes, Delete"
                        cancelText="Cancel"
                    >
                        <div className="rule-action-item rule-action-item--delete">
                            <DeleteOutlined style={{ fontSize: 15 }} /> Delete
                        </div>
                    </Popconfirm>
                </>
            )}
        </div>
    );

    const deleteUser = async (record) => {
        // console.log('deleteUser record:', record);
        let url = `${Config.url}cancellation-rule/${record.cancellation_rule_id}`
        try {
            const response = await axios.delete(url, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            // console.log(' Successful:', response);
            messageApi.success({
                type: 'succes',
                content: 'Rule deleted successfully',
            });
            getAllCancelData(CurrentPage)
        } catch (error) {
            console.log('deleteUser:', error.response?.data || error.message);
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message,
            });
        }
    }

    const handleRowClick = (record, editMode = false) => {
        setloader(true)
        setshowAddButton(false)
        setisUserCreateEnable(true)
        setMode(editMode ? 'edit' : 'view')
        setuserDataSet(record)
        form.setFieldsValue(record)
        setloader(false)
        setshowEditorOnlyAdd(false)
        seteditTextArea(null)
        seteditTextAreaemail(null)
        document.querySelector(".gpProductCreate-form")?.scrollIntoView({ behavior: "smooth" })
    }

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a style={{ color: '#4A4A4A' }}>Previous</a>;
        }
        if (type === 'next') {
            return <a style={{ color: '#4A4A4A' }}>Next</a>;
        }
        return originalElement;
    };
    const createUser = () => {
        form.setFieldsValue({
            charge_type: 'fixed'
        });
        setisUserCreateEnable(true)
        setMode('edit')
        setshowEditorOnlyAdd(true)
    }

    return (
        <App>
            {contextHolder}
            <>
             <Row gutter={24} style={{width:'80%', marginBottom: '10px'}}>
                    <Col span={24}>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}> */}
                    <div style={{ display: "flex", justifyContent: 'space-around', alignItems: "center", marginInline: 20 }}>
                        <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20, fontWeight: '400' }}>
                            All cancellation rules for all GP products and all clinics <span style={{ color: "black", fontWeight: '400' }}>({AllClinicianData?.total ? AllClinicianData?.total : '00'})</span>
                        </Title>
                       
                     </div>
                     </Col>
                </Row>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card
                        className='cancel-rule-card'
                        style={{ width: '80%', margin: 0, padding: 0, borderRadius: 40, padding: 0, paddingBottom: 20, boxShadow: "rgba(0, 0, 0, 0.15) 0px 0 6px" }}
                    >
                        <ConfigProvider
                            theme={{
                                components: {
                                    Table: {
                                        headerBg: "#008385",
                                        headerColor: "#ffffff",
                                    },
                                    Spin: {
                                        colorPrimary: "#008385", // Change this to your desired color
                                    },
                                },
                            }}
                        >
                            {AllClinicianData && <Table
                                className='table-heading'
                                loading={loader}
                                columns={columns}
                                dataSource={AllClinicianData?.data}
                                pagination={false}
                                onRow={(record) => ({
                                    onClick: () => handleRowClick(record, false),
                                })}
                                scroll={{
                                    x: 'auto',
                                    y: '350px',
                                }}
                                // style={{ height: '400px' }}
                            />}
                            {AllClinicianData && AllClinicianData?.total ? <Pagination
                                align="center"
                                defaultCurrent={1}
                                defaultPageSize={10}
                                total={AllClinicianData?.total ? AllClinicianData?.total : undefined}
                                style={{ marginTop: 10 }}
                                onChange={(val, filter) => {
                                    setCurrentPage(val)
                                }}
                                itemRender={itemRender}
                            /> : ''}
                        </ConfigProvider>
                    </Card>
                </div>
            </>
            {!isCorporateAdmin && <div className='button-add-left' style={{ display: "flex", justifyContent: "start", marginTop: 20 }}>
                {showAddButton && <Button type="default" className='add-generic-btn' style={{ marginTop: 20, paddingInline: 60, borderColor: '#008385', borderRadius: 5,marginBottom: 20 }} onClick={createUser}>Add a rule</Button>}
            </div>}
            <Row gutter={24} >
                <Col span={24}>
            <div className='gpProductCreate-form' >
                {/* {showAddButton && <Button type="default" className='add-generic-btn' style={{ marginTop: 20, marginLeft: '-6%', borderColor: '#008385' }} onClick={createUser}>Add a rule</Button>} */}
                {loader === false && isUserCreateEnable && (() => {
                    const initials = getInitials(userDataSet?.name);
                    const ruleName = userDataSet?.name || 'Rule';
                    const chargeType = userDataSet?.charge_type || form.getFieldValue('charge_type');
                    return (
                        <Card
                            className={isViewMode ? 'clinician-view-mode-card' : ''}
                            style={{
                                marginTop: 20, width: '80%', marginLeft: '10%',
                                borderRadius: 8, overflow: 'hidden',
                            }}
                            title={
                                isViewMode ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        <div style={{
                                            width: 38, height: 38, borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #008385, #00a3a5)',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0,
                                            boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                                        }}>
                                            {initials}
                                        </div>
                                        <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>{ruleName}</span>
                                    </div>
                                ) : (
                                    <span style={{ fontWeight: 600, fontSize: 15, color: '#1f1f1f' }}>Rule details</span>
                                )
                            }
                            extra={null}
                        >
                            {userDataSet && loader === false && (
                                <Form
                                    form={form}
                                    autoComplete="off"
                                    initialValues={userDataSet || null}
                                    onFinish={(values) => onFinish(values, userDataSet?.cancellation_rule_id && Object.keys(userDataSet).length ? true : false)}
                                >
                                    {isViewMode ? (
                                        <div style={{ padding: '0 4px' }}>
                                            <SectionDivider label="Rule Details" />
                                            <div className="clinician-view-detail-row">
                                                <label>Name</label>
                                                <span className="clinician-view-field-value">{userDataSet?.name || '-'}</span>
                                            </div>
                                            <div className="clinician-view-detail-row">
                                                <label>Charge Type</label>
                                                <Tag className="clinician-tag-pill">
                                                    {chargeType === 'percentage' ? '%' : '£'}
                                                </Tag>
                                            </div>
                                            <div className="clinician-view-detail-row">
                                                <label>Min. Period (hrs)</label>
                                                <span className="clinician-view-field-value">{userDataSet?.duration || '-'}</span>
                                            </div>
                                            <div className="clinician-view-detail-row">
                                                <label>Amount</label>
                                                <span className="clinician-view-field-value">{userDataSet?.amount || '-'}</span>
                                            </div>
                                            {/* Email & SMS copy — read-only, shown inside card in view mode */}
                                            <SectionDivider label="Email & SMS Copy" />
                                            <div style={{ display: 'flex', gap: 16, marginBottom: 8 }}>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ color: '#007a7c', fontWeight: 600, fontSize: 12, marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.4 }}>Cancellation Email Copy</div>
                                                    <div className='emailCopynew' dangerouslySetInnerHTML={{ __html: userDataSet?.cancellation_email_copy || '' }} style={{ width: '100%' }} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ color: '#007a7c', fontWeight: 600, fontSize: 12, marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.4 }}>Cancellation SMS Copy</div>
                                                    <div className='emailCopynew' dangerouslySetInnerHTML={{ __html: userDataSet?.cancellation_sms_copy ?? '' }} style={{ width: '100%' }} />
                                                </div>
                                            </div>
                                            {/* View mode bottom buttons */}
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 20, paddingBottom: 4 }}>
                                                <Button
                                                    onClick={() => {
                                                        setuserDataSet({}); setisUserCreateEnable(false);
                                                        setMode('edit'); setshowAddButton(true); setshowEditorOnlyAdd(true);
                                                    }}
                                                    style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                                                >Cancel</Button>
                                                <Button
                                                    className="edit-btn-green"
                                                    icon={<EditOutlined />}
                                                    onClick={() => setMode('edit')}
                                                    style={{ minWidth: 100 }}
                                                >Edit</Button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                                                <Form.Item
                                                    label="Name" name="name"
                                                    rules={[{ required: true, message: 'Name is required.' }]}
                                                    style={{ flex: 1, minWidth: 140 }}
                                                >
                                                    <Input disabled={isCorporateAdmin} placeholder="Name" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Charge type" name="charge_type"
                                                    rules={[{ required: true, message: 'Charge type is required.' }]}
                                                    style={{ flex: 1, minWidth: 120 }}
                                                >
                                                    <Select disabled={isCorporateAdmin} placeholder="Charge type" defaultValue="fixed">
                                                        <Option value="fixed">£</Option>
                                                        <Option value="percentage">%</Option>
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    label="Min. period (hrs)" name="duration"
                                                    rules={[
                                                        { required: true, message: 'Min. period is required.' },
                                                        { pattern: /^[0-9]+$/, message: 'Enter a valid number (e.g., 10)' },
                                                    ]}
                                                    style={{ flex: 1, minWidth: 140 }}
                                                >
                                                    <Input disabled={isCorporateAdmin} placeholder="Duration" />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Amount" name="amount"
                                                    rules={[
                                                        { required: true, message: 'Amount is required.' },
                                                        { pattern: /^\d+(\.\d{1,2})?$/, message: 'Enter a valid number (e.g., 10.99)' },
                                                    ]}
                                                    style={{ flex: 1, minWidth: 120 }}
                                                >
                                                    <Input disabled={isCorporateAdmin} placeholder="Amount" />
                                                </Form.Item>
                                            </div>
                                            {/* Edit mode bottom buttons */}
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 16, paddingBottom: 4 }}>
                                                <Button
                                                    onClick={() => {
                                                        form.setFieldsValue({ name: '', duration: '', charge_type: '', amount: '' });
                                                        setuserDataSet({}); setisUserCreateEnable(false);
                                                        setMode('edit'); setshowAddButton(true); setshowEditorOnlyAdd(true);
                                                    }}
                                                    style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                                                >Cancel</Button>
                                                {!isCorporateAdmin && (
                                                    <Button
                                                        htmlType="submit"
                                                        loading={isSubmitting}
                                                        disabled={isSubmitting}
                                                        className={isSubmitting ? 'btn-solid-primary-submitting' : 'btn-solid-primary'}
                                                        style={{
                                                            minWidth: 100,
                                                        }}
                                                    >{isSubmitting ? 'Saving...' : 'Save'}</Button>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </Form>
                            )}
                        </Card>
                    );
                })()}
            </div>
            </Col>
            </Row>
            {loader == false && isUserCreateEnable && !isViewMode && <div style={{  marginTop: 40,width: '80%', marginLeft: '10%' }}>
                <Row gutter={24}>
                    <Col span={12}>
                <Form.Item name='cancellation_email_copy'>
                    <div style={{ textAlign: 'left', alignItems: 'flex-start', color: '#4a4a4a', marginBottom: 2, fontSize: 15  }}>
                        Cancellation Email copy
                    </div>
                    {isViewMode ? (
                        <div className='emailCopynew' dangerouslySetInnerHTML={{ __html: userDataSet?.cancellation_email_copy || '' }} style={{width: '100%'}} />
                    ) : (
                        <>
                            {(editTextAreaemail != 'email_copy' && !showEditorOnlyAdd) && <>
                                <div className='emailCopynew' dangerouslySetInnerHTML={{ __html: userDataSet?.cancellation_email_copy ? userDataSet?.cancellation_email_copy : null }} style={{width: '100%'}} />
                                <EditOutlined
                                    style={{
                                        position: "absolute",
                                        top: 30,
                                        right: 10,
                                        fontSize: 18,
                                        color: "#999",
                                        cursor: "pointer",
                                        maxWidth: "460px"
                                    }}
                                    onClick={() => seteditTextAreaemail('email_copy')}
                                />
                            </>}
                            {(editTextAreaemail == 'email_copy' || showEditorOnlyAdd) && (
                                <Editor
                                    apiKey={Config.apiKey}
                                    onInit={(_evt, editor) => editorRef.current = editor}
                                    initialValue={userDataSet?.cancellation_email_copy || ''}
                                    disabled={isCorporateAdmin}
                                    init={{
                                        height: 150,
                                        marginTop: 50,
                                        menubar: false,
                                        plugins: [
                                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                        ],
                                        toolbar: 'undo redo | blocks | customDropdown ' +
                                            'bold italic forecolor | alignleft aligncenter ' +
                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                            'removeformat ' + 'link | unlink',
                                        setup: (editor) => {
                                            customDropdown(editor, 'short-codes')
                                        },
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                        placeholder: 'Cancellation Email copy',
                                    }}
                                />
                            )}
                        </>
                    )}
                </Form.Item>
                 </Col>
                <Col span={12}>
                <Form.Item name='cancellation_sms_copy' >
                    <div style={{ textAlign: 'left', alignItems: 'flex-start', color: '#4a4a4a', marginBottom: 2, fontSize: 15 }}>
                        Cancellation sms copy
                    </div>
                    {isViewMode ? (
                        <div className='emailCopynew' dangerouslySetInnerHTML={{ __html: userDataSet?.cancellation_sms_copy ?? '' }} style={{width: '100%'}} />
                    ) : (
                        <>
                            {(editTextArea != 'sms_copy' && !showEditorOnlyAdd) && <>
                                <div className='emailCopynew' dangerouslySetInnerHTML={{ __html: userDataSet?.cancellation_sms_copy ?? '' }} style={{width: '100%'}} />
                                <EditOutlined
                                    style={{
                                        position: "absolute",
                                        top: 30,
                                        right: 10,
                                        fontSize: 18,
                                        color: "#999",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => seteditTextArea('sms_copy')}
                                />
                            </>}
                            {(editTextArea == 'sms_copy' || showEditorOnlyAdd) && (
                                <Editor
                                    apiKey={Config.apiKey}
                                    disabled={isCorporateAdmin}
                                    onInit={(_evt, editor) => {
                                        editorRef1.current = editor;
                                        const editorId = editor.id;
                                        editor.on('SkinLoaded', () => {
                                            const textOnly = editor.getContent({ format: 'text' }) || '';
                                            const remaining = Math.max(0, textOnly.length);
                                            if (!charCountRefs.current[editorId]) {
                                                const label = document.createElement('div');
                                                label.style.marginTop = '0';
                                                label.style.color = '#aaa';
                                                label.style.textAlign = 'center';
                                                label.innerText = `${remaining ?? 0}/${MAX_CHARS}`;
                                                charCountRefs.current[editorId] = label;
                                                const container = editor.getContainer();
                                                if (container) {
                                                    container.appendChild(label);
                                                }
                                            }
                                        });
                                        editor.on('keydown', (e) => {
                                            const content = editor.getContent({ format: 'text' });
                                            if (content.length >= MAX_CHARS && ![8, 46, 37, 38, 39, 40].includes(e.keyCode)) {
                                                e.preventDefault();
                                            }
                                        });
                                    }}
                                    initialValue={userDataSet?.cancellation_sms_copy ? userDataSet?.cancellation_sms_copy : null}
                                    init={{
                                        height: 150,
                                        marginTop: 50,
                                        menubar: false,
                                        plugins: ['link'],
                                        toolbar: 'undo redo | blocks |  link | unlink',
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                        placeholder: 'Cancellation sms copy',
                                    }}
                                    onEditorChange={(newContent, editor) => {
                                        const textOnly = editor.getContent({ format: 'text' }) || '';
                                        const remaining = Math.max(0, textOnly.length);
                                        const label = charCountRefs.current[editor.id];
                                        if (label) {
                                            label.innerText = `${remaining}/${MAX_CHARS}`;
                                        }
                                        if (textOnly.length > MAX_CHARS) {
                                            const trimmed = textOnly.substring(0, MAX_CHARS);
                                            editor.setContent(trimmed);
                                        }
                                    }}
                                />
                            )}
                        </>
                    )}
                </Form.Item>
                </Col>
                 </Row>

            </div>}

        </App>
    )
}

export default CancelRule